module.exports = __webpack_public_path__ + "img/banned.1c1ae1a8.jpg";